/* global $ */
const invoiceAffix = (element) => {
  const footerOffset = 160;
  const scroll = $(window).scrollTop();
  const affixBar = $(element);
  const condition = $(document).scrollTop() + window.innerHeight < $('.footer').offset().top - footerOffset;

  if (condition && scroll < 80) {
    affixBar.addClass('affixed not-visible');
  } else if (condition && scroll >= 80) {
    affixBar.addClass('affixed');
    affixBar.removeClass('not-visible');
  } else {
    affixBar.removeClass('affixed not-visible');
  }
};

const bindInvoiceAffix = (element) => {
  $(document).scroll(() => {
    invoiceAffix(element);
  });

  $(document).ready(() => {
    invoiceAffix(element);
  });
};

export default bindInvoiceAffix;
